/* Svensk katalog for locale-payroll-runs-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'pay.salaryTypeSaved': 'Lönetyp sparad.',
  'pay.salaryTypeSaveFailed': 'Det gick inte att spara lönetypen.',
  'pay.fixedLineSaved': 'Fast lönerad sparad.',
  'pay.fixedLineSaveFailed': 'Det gick inte att spara den fasta löneraden.',
  'pay.fillNameAndAccountNumber': 'Fyll i namn och kontonummer.',
  'pay.accountAdded': 'Konto tillagt.',
  'pay.addAccountFailed': 'Det gick inte att lägga till kontot.',
  'pay.calculationCodeNotSupported': 'Den här beräkningskoden för arbetsgivaravgift stöds inte ännu. Välj Allmänna näringar.',
  'pay.payrollSettingsSaved': 'Löneinställningar sparade.',
  'pay.payrollSettingsSavedWithRecalc': 'Löneinställningar sparade. {count} öppna löneutkast har beräknats på nytt.',
  'pay.payrollSettingsSaveFailed': 'Det gick inte att spara löneinställningarna.',
  'pay.markedManualSubmission': 'Markerad som manuell inlämning.',
  'pay.ameldingSentToAltinn': 'A-melding skickad till Altinn.',
  'pay.payslipsCreatedAndPosted': 'Lönebesked skapade och lön bokförd. Lönebeskeden kan skickas senare.',
  'pay.payrollRunEditableAgain': 'Löneutbetalningen kan ändras igen.',
  'pay.accountingAnnulled': 'Bokföringen har annullerats.',
  'pay.payrollRunAnnulled': 'Löneutbetalning annullerad.',
  'pay.payoutRegistered': 'Utbetalning registrerad.',
  'pay.confirmAnnulPayment': 'Annullera den här betalningen? Bokföringen återförs genom att betalningen inte längre tas med.',
  'pay.hideDeletedPayrollRuns': 'Dölj borttagna löneutbetalningar',
  'pay.showDeletedPayrollRuns': 'Visa borttagna löneutbetalningar ({count})',
  'pay.removePermanently': 'Ta bort permanent',
  'pay.removeDeletedPayrollRunPermanently': 'Ta bort borttagen löneutbetalning permanent',
  'pay.confirmRemoveDeletedPayrollRunTitle': 'Ta bort borttagen löneutbetalning?',
  'pay.confirmRemoveDeletedPayrollRunMessage': 'Detta tar bort utkastet för {period} permanent. Endast lön som aldrig har godkänts, skickats eller bokförts kan tas bort här.',
  'pay.editPaymentTitle': 'Redigera betalning',
  'pay.registerPaymentTitle': 'Registrera betalning',
  'pay.savingEllipsis': 'Sparar...',
  'pay.savePaymentAction': 'Spara betalning',
  'pay.editSalaryTypeTitle': 'Redigera lönetyp',
  'pay.newFixedLineTitle': 'Ny fast lönerad',
  'pay.editFixedLineTitle': 'Redigera fast lönerad',
  'pay.operatingAccount': 'Företagskonto',
  'pay.newWithholdingAccountTitle': 'Nytt skatteavdragskonto',
  'pay.newPayrollAccountTitle': 'Nytt lönekonto',
  'pay.addAccountAction': 'Lägg till konto',
  'pay.totalPay': 'Sammanlagd lön',
  'pay.taxDeduction': 'Skatteavdrag',
  'pay.voucher': 'Verifikation',
  'pay.basis': 'Underlag',
  'pay.payrollRuns': 'Lönekörningar',
  'pay.agaOfHolidayPayFull': 'AGA på semesterersättning',
  'pay.deadline': 'Deadline',
  'pay.paidAmount': 'Betalt',
  'pay.remaining': 'Återstår',
  'pay.provider': 'Leverantör',
  'pay.orgNumber': 'Org.nr',
  'pay.earnedAtStandardRate': 'Intjänat (10,2 %)',
  'pay.ameldingRegistered': 'A-melding registrerad',
  'pay.noSubmissions': 'Inga inlämningar',
  'pay.posted': 'Bokförd',
  'pay.notPosted': 'Inte bokförd',
  'pay.payslipsNotGenerated': 'Lönebesked har inte genererats.',
  'pay.employmentSetOnEmployeePage': 'Anställning anges på sidan för anställda',
  'pay.rulesFromSalaryType': 'Regler från lönetypen',
  'pay.useStandardRules': 'Använd standardreglerna',
  'pay.advancedSettings': 'Avancerade inställningar',
  'pay.overrideCanChangeCalculation': 'Åsidosättning kan ändra skatt, arbetsgivaravgift, semesterersättning, OTP och bokföring för den här raden.',
  'pay.removeFromFixedLines': 'Ta bort den här från fasta lönerader',
  'pay.makeThisAFixedLine': 'Gör den här till en fast lönerad',
  'pay.withholdingExceedsCashPayWarning': 'Skatteavdraget är högre än kontantlön och ersättningar. Lägg till kontantlön eller minska avdraget innan lönekörningen kan godkännas.',
  'pay.attachDocumentationHint': 'Bifoga dokumentation för löneutbetalningen, till exempel tidrapporter eller manuella reseräkningar.',
  'pay.upload': 'Ladda upp',
  'pay.step1AltinnHelp': 'När alla rader är med är nästa steg att rapportera in löneutbetalningen. Altinn-integrationen kopplas på senare, så meddelandet kan markeras som manuell inlämning nu.',
  'pay.step3PayslipsHelp': 'När löneutbetalningen är inrapporterad och godkänd skapas lönebesked och lönen bokförs.',
  'pay.step4PaymentHelp': 'Registrera och bokför utbetalning av lön till anställda och skatteavdrag till Skatteetaten.',
  'pay.payrollRunCompletesWhenPaid': 'Löneutbetalningen slutförs när betalningen är registrerad.',
  'pay.productionSupportedProfile': 'Profil som stöds i produktion: norsk lön, månadsperiod, Allmänna näringar och procentkort. Tabellkort, särskilda AGA-koder och elektronisk inlämning utan kvitto är blockerade.',
  'pay.searchMunicipalityOrNumber': 'Sök kommun eller nummer',
  'pay.notSupportedYet': 'stöds inte ännu',
  'pay.chooseGeneralIndustriesWarning': 'Välj Allmänna näringar innan inställningarna kan sparas. Den tidigare valda beräkningskoden är inte implementerad.',
  'pay.searchProvider': 'Sök leverantör',
  'pay.month.may': 'Maj',
  'pay.payTypeNotFixedLine': 'Den här lönetypen kan inte användas som fast lönerad.',
  'pay.calculationCodeUnsupportedShort': 'Den här beräkningskoden för arbetsgivaravgift stöds inte ännu.',
  'pay.overtimePay': 'Övertid',
  'pay.mileageAllowance': 'Milersättning',
  'pay.driveFallback': 'Körning',
  'pay.taxableMileagePortion': 'Skattepliktig del',
  'pay.expenseCategoryOther': 'Övrigt',
  'pay.overnightStayFallback': 'Övernattning',
  'pay.hotelFallback': 'Hotell',
  'pay.mileagePayoutFallback': 'Körersättning',
  'pay.ownCar': 'Egen bil',
  'pay.travelPurposeFallback': 'Resa',
  'pay.taxTermWithholdingLabel': 'Skatteavdrag {{date}}',
  'pay.taxTermAgaLabel': '{{term}}:a terminen',
  'pay.payrollRunNotEditableForNewLines': 'En godkänd lönekörning kan inte få nya lönerader.',
  'pay.payTypeNotManualEntry': 'Den här lönetypen kan inte läggas till manuellt.',
  'pay.receiptInboxFallbackName': 'Verifikation från inkorgen',
  'pay.approvedButPayslipsFailed': 'Lönen är bokförd, men lönebeskeden skickades inte: {{error}}',
  'pay.recon.runLabelPeriod': 'Lön {{period}}',
  'pay.recon.runLabelRun': 'Körning {{date}}',
  'pay.recon.notPaid': 'Inte utbetald',
  'pay.recon.paidAfterPeriod': 'Utbetald efter periodens datum',
  'pay.recon.flag.negativ_netto': 'Negativ nettolön',
  'pay.recon.flag.mangler_skattekort': 'Skattekort saknas',
  'pay.recon.flag.sluttet_ansatt': 'Utbetalning till anställd som slutat',
  'pay.recon.flag.naturalytelse': 'Förmån att kontrollera',
  'pay.recon.flag.uvanlig_endring': 'Onormal löneförändring',
  'pay.recon.flag.mangler_amelding': 'Saknas i A-melding',
  'pay.recon.flag.mulig_duplikat': 'Möjlig dubbelutbetalning',
  'pay.recon.flag.ikke_utbetalt': 'Inte utbetald',
  'pay.recon.unknownEmployee': 'Okänd anställd',
  'pay.recon.employmentTypeFixed': 'Fast',
  'pay.recon.reported': 'Rapporterad',
  'pay.recon.notReported': 'Inte rapporterad',
  'pay.recon.afterPeriodDate': 'Efter periodens datum',
  'pay.recon.role.forskuddstrekk': 'Skatteavdrag under perioden',
  'pay.recon.role.aga': 'Beräknad arbetsgivaravgift på lön',
  'pay.recon.role.aga_feriepenger': 'Beräknad arbetsgivaravgift på semesterersättning',
  'pay.recon.role.feriepenger': 'Semesterlöneskuld enligt lönesystemet',
  'pay.recon.role.skyldig_lonn': 'Nettolön och avdrag från lönesystemet',
  'pay.recon.role.pensjon': 'Pensionspremie från lönesystemet',
  'pay.recon.row.brutto': 'Bruttolön',
  'pay.recon.row.naturalytelser': 'Skattepliktiga förmåner',
  'pay.recon.row.trekkpliktige': 'Avdragspliktiga ersättningar',
  'pay.recon.row.godtgjorelser': 'Kostnadsersättningar',
  'pay.recon.row.aga_grunnlag': 'Underlag för arbetsgivaravgift',
  'pay.recon.row.aga': 'Beräknad arbetsgivaravgift',
  'pay.recon.row.netto': 'Nettolön',
  'pay.recon.row.andre_trekk': 'Andra avdrag',
  'pay.recon.row.feriepenger': 'Intjänad semesterersättning',
  'pay.recon.row.pensjon': 'Pensionspremie',
  'pay.recon.source.payrollSystem': 'Lönesystem',
  'pay.recon.source.bankPayouts': 'Bankutbetalningar',
  'pay.recon.source.pensionBasis': 'Pensionsunderlag',
  'pay.recon.source.payrollSystemDetailSingular': '{{count}} bokförd körning under perioden',
  'pay.recon.source.payrollSystemDetailPlural': '{{count}} bokförda körningar under perioden',
  'pay.recon.source.payrollSystemDetailEmpty': 'Inga bokförda lönekörningar under perioden',
  'pay.recon.source.ledgerDetail': '{{count}} konteringar på lönekontona',
  'pay.recon.source.ledgerDetailEmpty': 'Inga konteringar på kontona som har lagts till i löneområdet',
  'pay.recon.source.ameldingDetailNone': 'Inga körningar att rapportera',
  'pay.recon.source.ameldingDetailAllReported': '{{reported}} av {{total}} körningar är registrerade som rapporterade',
  'pay.recon.source.ameldingDetailMissing': '{{missing}} av {{total}} körningar är inte registrerade som rapporterade',
  'pay.recon.source.bankDetailNone': 'Inga körningar att betala',
  'pay.recon.source.bankDetailPaid': '{{paid}} av {{total}} körningar är registrerade som utbetalda',
  'pay.recon.source.pensionDetailPresent': 'Pensionspremie beräknad av lönesystemet',
  'pay.recon.source.pensionDetailNone': 'Ingen pensionspremie under perioden',
  'pay.recon.check.bokfort': 'Alla lönekörningar är bokförda',
  'pay.recon.check.hovedbok': 'Lönesystemet stämmer med huvudboken',
  'pay.recon.check.kontrollkontoer': 'Kontrollkontona stämmer med underlaget',
  'pay.recon.check.bank': 'Nettolönen är utbetald',
  'pay.recon.check.amelding': 'A-melding är registrerad som inlämnad',
  'pay.recon.check.skattekort': 'Alla anställda har giltigt skattekort',
  'pay.recon.check.negativ': 'Inga negativa nettobelopp',
  'pay.recon.check.duplikat': 'Möjliga dubbelutbetalningar är identifierade',
  'pay.recon.check.uvanlig': 'Ovanliga löneändringar är identifierade',
  'pay.recon.check.sluttet': 'Utbetalningar till anställda som slutat är identifierade',
  'pay.recon.check.naturalytelse': 'Naturaförmåner är analyserade',
  'pay.recon.check.feriepenger': 'Semesterlöneskulden är avstämd',
  'pay.recon.check.termin': 'Skatteavdrag och arbetsgivaravgift är reglerade',
  'pay.creatingRun': 'Skapar…',
  'pay.pensionPremiumAmount': 'Faktisk pensionspremie',
  'pay.pensionBankAmount': 'Betalt från bank',
  'pay.pensionFeeAmount': 'Särskild avgift (brutto)',
  'pay.pensionFeeVat': 'Moms på avgift',
  'pay.pensionFeeAccount': 'Kostnadskonto för avgift',
  'pay.pensionOverpaymentNotice': 'Differensen bokförs som förskott till pensionsleverantören på konto 1570.',
  'pay.createLaterCorrection': 'Skapa korrigering i senare period',
  'pay.createCorrection': 'Skapa korrigering',
  'pay.laterCorrectionHelp': 'Den ursprungliga körningen behålls. När korrigeringen godkänns bokförs bara differensen i den nya perioden.',
  'pay.correctionCreated': 'Korrigeringskörningen har skapats som utkast.',
  'pay.typeStandard': 'Standard',
  'pay.typeCustom': 'Egen',
  'pay.statusInactive': 'Inaktiv',
  'pay.ruleTag.aga': 'Arb.avg.',
  'pay.ruleTag.tax': 'Skatt',
  'pay.ruleTag.holiday': 'Sem.lön',
  'pay.ruleTag.pension': 'OTP',
  'pay.ruleTitle.aga': 'Arbetsgivaravgiftspliktig',
  'pay.ruleTitle.tax': 'Skatteavdragspliktig',
  'pay.ruleTitle.holiday': 'Semesterlönegrundande',
  'pay.ruleTitle.pension': 'Pensionsgrundande',
  'pay.stdType.monthly-salary': 'Fast lön',
  'pay.stdType.hourly': 'Timlön - inte övertid',
  'pay.stdType.overtime-hourly': 'Timlön - övertid',
  'pay.stdType.commission-pay': 'Arvode, ackord, procent- eller provisionslön',
  'pay.stdType.bonus-holiday-pay': 'Bonus, semesterlönegrundande',
  'pay.stdType.bonus-no-holiday-pay': 'Bonus, inte semesterlönegrundande',
  'pay.stdType.board-fee': 'Styrelsearvode',
  'pay.stdType.company-car': 'Bilförmån',
  'pay.stdType.other-benefits': 'Andra förmåner',
  'pay.stdType.taxable-insurance': 'Försäkringar, skattepliktig del',
  'pay.stdType.car-km-allowance': 'Milersättning',
  'pay.stdType.car-km-allowance-taxable': 'Milersättning, skatteavdragspliktig del',
  'pay.stdType.holiday-pay-current': 'Semesterlön intjänad innevarande år',
  'pay.stdType.holiday-pay-previous': 'Semesterlön intjänad tidigare år',
  'pay.stdType.pension-premium': 'Pensionspremie OTP',
  'pay.stdType.canteen-deduction': 'Kantinavdrag',
  'pay.stdType.holiday-deduction': 'Löneavdrag för semester',
  'pay.stdType.extra-tax-deduction': 'Extra skatteavdrag',
  'pay.stdType.employee-expense-settlement': 'Utläggsersättning resa',
  'pay.stdType.overnight-diet-hotel': 'Traktamente vid övernattning',
});
